import { Machine, assign, spawn } from 'xstate';
import { newMachine } from './newMachine';
import { wpFetchRestApi, isWpSuccess } from '../util';
;
;
const spawnNewTypeMachine = assign({
    newMachine: () => spawn(newMachine.withContext({ values: { for_sale: true } }), {
        name: 'new-machine',
        sync: true,
    }),
});
const adminTypesMachine = Machine({
    id: 'admin-types-machine',
    initial: 'editing',
    states: {
        editing: {
            // @ts-ignore
            entry: [
                spawnNewTypeMachine,
            ],
            on: {
                SAVED: 'fetching',
            },
        },
        fetching: {
            invoke: {
                src: 'fetchTypes',
                onDone: {
                    actions: 'assignTypes',
                    target: 'editing',
                },
                onError: {
                    actions: 'assignError',
                    target: 'error',
                },
            }
        },
        error: {
            on: {
                RELOAD: 'fetching',
            }
        },
    }
}, {
    actions: {
        assignTypes: assign({
            types: (__, evt) => evt.data,
        }),
        assignError: assign({
            error: (__, evt) => evt.data,
        }),
    },
    services: {
        fetchTypes: fetchTypes,
    },
});
async function fetchTypes() {
    const endpoint = 'meeting-type/';
    const result = await wpFetchRestApi(endpoint, 'GET');
    if (isWpSuccess(result)) {
        return result.data;
    }
    throw new Error(result.message);
}
export function createAdminTypesMachine(types) {
    return adminTypesMachine.withContext({ types });
}
